import { Academy } from './Academy';
import { Bill } from './Bill';
import { Post } from './Post';
import { Attendance } from './Attendance';
import { Chat } from './Chat';
import { Homework } from './Homework';
import { Message } from './Message';
import { Push } from './Push';
import { Report } from './Report';
import { Feature } from './Feature';

const Co = {
  Academy,
  Bill,
  Post,
  Attendance,
  Homework,
  Chat,
  Message,
  Push,
  Report,
  Feature,
};

export default Co;
